import { Stack } from '@mui/material';
import { SidebarLink } from '@side/pantry';
import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import { useAgentTeamId } from '@/utils/use-agent-team-id';
import { AnalyticsEvent, useTrackEvent } from '$analytics';
import { useAppFlags } from '$launchdarkly/useAppFlags';
import {
  ACCOUNT_NAVIGATION_LINKS,
  AccountNavigationLabel,
} from './accountNavigation';
import { useAccountSettingsLogic } from './useAccountSettingsLogic';
import { ViewTeamSelector } from './ViewTeamSelector';

export const NavigationAccordion = () => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const trackEvent = useTrackEvent();
  const { agentTeamId } = useAgentTeamId();
  const { identityUpdateRoles } = useAppFlags();

  const teamId = searchParams?.get('team') ?? agentTeamId;

  const { teams, handleTeamChange } = useAccountSettingsLogic();

  const basePath = process.env.NEXT_PUBLIC_BASE_PATH ?? '';
  const fullCurrentPath = `${basePath}${pathname ?? ''}`;

  return (
    <Stack>
      {!identityUpdateRoles && (
        <ViewTeamSelector
          teams={teams}
          teamId={teamId}
          handleTeamChange={(event) => handleTeamChange(event.target.value)}
          sx={{
            mt: 3,
            mb: 3,
          }}
        />
      )}
      {ACCOUNT_NAVIGATION_LINKS.map((link) => {
        const isActive = fullCurrentPath === link.pathname;

        return (
          <SidebarLink
            key={link.pathname}
            label={link.label}
            pathname={link.pathname}
            linkComponent={Link}
            basePath={basePath}
            currentPath={pathname ?? ''}
            active={isActive}
            onClick={() => {
              switch (link.label) {
                case AccountNavigationLabel.AccountProfile:
                  trackEvent(AnalyticsEvent.Sidebar, {
                    eventTarget: 'account_profile',
                  });
                  break;
                case AccountNavigationLabel.TeamManagement:
                  trackEvent(AnalyticsEvent.Sidebar, {
                    eventTarget: 'team_management',
                  });
                  break;
                case AccountNavigationLabel.Notifications:
                  trackEvent(AnalyticsEvent.Sidebar, {
                    eventTarget: 'notifications',
                  });
                  break;
                default:
                  break;
              }
            }}
          />
        );
      })}
    </Stack>
  );
};
